<script setup>
// @ts-check

import CardDialog from '@/components/dialogs/CardDialog.vue'
import { computed, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  entryModule: {
    /** @type {import('vue').PropType<'incomes'|'expenses'|'bank_transactions'>} */
    type: String,
    required: true
  }
})

const emit = defineEmits(['close'])

defineOptions({
  name: 'EntriesListTitleInfoDialog'
})

const { t } = useI18n()
const { entryModule } = toRefs(props)

const infoText = computed(() => {
  switch (entryModule.value) {
    case 'incomes':
      return t('entries.info_texts.incomes')
    case 'expenses':
      return t('entries.info_texts.expenses')
    case 'bank_transactions':
      return t('bank_transactions.overview.base')
    default:
      return null
  }
})
const bookkeepingLinkText = computed(() => {
  if (entryModule.value === 'incomes' || entryModule.value === 'expenses') {
    return t('entries.info_texts.bookkeeping_link_text')
  }
  return null
})
</script>

<template>
  <CardDialog
    hide-cancel
    :aria-label="`${entryModule}_title_info_dialog`"
    @action="emit('close')"
    @close="emit('close')"
  >
    <div class="flex flex-col items-start gap-content">
      <p v-if="infoText">{{ infoText }}</p>

      <RouterLink
        v-if="bookkeepingLinkText"
        class="mb-2 flex items-center font-medium text-primary hover:underline sm:mb-0"
        :to="{ name: 'general_journal' }"
        @click="emit('close')"
      >
        {{ bookkeepingLinkText }}
        <VIcon icon="$chevron-right" />
      </RouterLink>
    </div>

    <template #action>
      {{ t('general.close') }}
    </template>
  </CardDialog>
</template>

<style lang="scss" scoped>
@reference '../../../styles/main.css';

:deep(.v-btn__content) {
  @apply whitespace-normal!;
}
</style>
